/* ADT2: Geschenk-Logik im Warenkorb.
   - Ab 2 Adventskalendern (adt_cal_2) kommt die Teekanne TP33 automatisch als großes Geschenk dazu.
   - Sonst ab der großen Schwelle: großes Geschenk automatisch (Golden Leaf, Ausweichsorten der Reihe nach), keine Auswahl mehr.
   - Teekanne wird entfernt, sobald weniger als 2 Kalender im Warenkorb sind. */
(function () {
  var CAL = 52373154398509;
  var TEAPOT = 52370181849389;
  var BIG_FALLBACKS = [51261612622125, 52165367202093, 51261613343021];

  function patch() {
    var inst = window.__cartDrawerPromos;
    if (!inst || inst.__adt2) return !!inst;
    var proto = Object.getPrototypeOf(inst);
    proto.__adt2 = true;

    proto.countCalendars = function (cart) {
      var n = 0;
      (cart.items || []).forEach(function (i) {
        if (i.variant_id === CAL && !(i.properties && i.properties._cart_promo)) n += i.quantity;
      });
      return n;
    };

    proto.tryAdd = async function (variantId, props) {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1, properties: props })
      });
      return r.ok;
    };

    proto.syncGiftLines = async function (cart) {
      var summary = this.summarizeCart(cart);
      var th = this.config.thresholds;
      var changed = false;
      var self = this;

      var wantSmall = summary.totalPrice >= th.gift && !!this.config.freeGiftVariantId;
      if (!wantSmall) {
        for (var a = 0; a < summary.freeGiftItems.length; a++) { await this.changeByKey(summary.freeGiftItems[a].key, 0); changed = true; }
      } else if (summary.freeGiftItems.length === 0) {
        await this.addVariant(this.config.freeGiftVariantId, { _cart_promo: 'free_gift', _cart_promo_source: 'cart_drawer_promos' });
        changed = true;
      } else {
        var fg = summary.freeGiftItems;
        if (fg[0].quantity !== 1) { await this.changeByKey(fg[0].key, 1); changed = true; }
        for (var b = 1; b < fg.length; b++) { await this.changeByKey(fg[b].key, 0); changed = true; }
      }

      var cals = this.countCalendars(cart);
      var target = null;
      if (cals >= 2) target = [TEAPOT];
      else if (summary.totalPrice >= th.bigGift) target = BIG_FALLBACKS;

      var big = summary.bigGiftItems;
      var keep = null;
      for (var i = 0; i < big.length; i++) {
        var ok = target && target.indexOf(big[i].variant_id) !== -1 && !keep;
        if (ok) {
          keep = big[i];
          if (big[i].quantity !== 1) { await this.changeByKey(big[i].key, 1); changed = true; }
        } else {
          await this.changeByKey(big[i].key, 0); changed = true;
        }
      }
      if (target && !keep) {
        for (var j = 0; j < target.length; j++) {
          if (await self.tryAdd(target[j], { _cart_promo: 'big_free_gift', _cart_promo_source: 'cart_drawer_promos' })) { changed = true; break; }
        }
      }
      return changed;
    };

    proto.getState = function (summary) {
      var th = this.config.thresholds;
      if (summary.totalPrice < th.shipping) return 'below_shipping';
      if (summary.totalPrice < th.gift) return 'below_gift';
      if (summary.hasBigGift) return 'complete';
      if (summary.totalPrice < th.bigGift) return 'below_big_gift';
      return 'complete';
    };

    if (typeof inst.init === 'function') inst.init();
    return true;
  }

  if (!patch()) {
    var tries = 0;
    var t = setInterval(function () { if (patch() || ++tries > 40) clearInterval(t); }, 150);
  }
})();